import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FracStage, FracStageMesh, StageMeshVolumeUpdate } from '~lmo/models/frac.model';
import { sortByPreferredOrder } from '~lmo/models/mesh.model';
import { LmoFracsService } from '~lmo/services';
import { LmoFracModalService } from '~lmo/services/lmo-frac-modal.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-stages-edit',
  styleUrls: ['./lmo-frac-stages-edit.component.scss'],
  templateUrl: './lmo-frac-stages-edit.component.html',
})
export class LmoFracStagesEditComponent implements OnInit {
  public currentFracStage$: Observable<FracStage>;
  public stageMeshFormSkeleton$: Observable<FracStageMesh[]>;
  public isStageDeletable$: Observable<boolean>;
  public pumpedForm: FormGroup;
  constructor(
    private modalService: LmoFracModalService,
    private fracService: LmoFracsService,
    private fb: FormBuilder,
  ) {}

  public ngOnInit() {
    this.currentFracStage$ = this.fracService.currentFracStageSelected$;
    this.isStageDeletable$ = combineLatest(this.fracService.currentFrac$, this.currentFracStage$).pipe(
      map(([currentFrac, currentStage]) => {
        if (currentFrac.completed) {
          return false;
        }
        return currentStage.stageNumber === currentFrac.currentStage - 1;
      }),
    );

    this.stageMeshFormSkeleton$ = this.currentFracStage$.pipe(
      map((currentStage) => sortByPreferredOrder(currentStage.meshes)),
    );

    this.stageMeshFormSkeleton$.pipe(take(1)).subscribe((meshes) => {
      const tempFormGroup = this.fb.group({});
      meshes.forEach((mesh) => {
        tempFormGroup.addControl(`${mesh.id}`, this.fb.control(mesh.actualVolume, [Validators.required]));
      });
      this.pumpedForm = tempFormGroup;
    });
  }

  public updateStage() {
    if (this.pumpedForm.invalid) {
      return;
    }
    const value: Record<string, number> = this.pumpedForm.value;
    const stageMeshVolumeUpdate: StageMeshVolumeUpdate[] = Object.keys(value)
      .map((key) => [+key, value[key]] as [number, number])
      .map(([meshId, actualVolume]) => ({
        actualVolume,
        meshId,
      }));
    this.fracService.updateStage$(stageMeshVolumeUpdate).subscribe((results) => {
      if (results) {
        this.modalService.closeStageModal();
      }
    });
  }

  public deleteStage() {
    this.fracService.deleteStage$().subscribe((results) => {
      if (results) {
        this.modalService.closeStageModal();
      }
    });
  }
}
